module.exports = __webpack_public_path__ + "static/media/eg.03b01cb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/eg.svg
// module id = 1443
// module chunks = 0